import React from 'react'
import PropTypes from 'prop-types'

const Header = ({ step }) => {
  return (
    <div className='col-12 '>
      <div className='checkout-step-address checkout-step row px-2 border-bottom border-top border-color-ui-3 '>
        <div className='col-auto px-1'>
          <div className='row mx-0 align-items-center h-100'>
            <i className={`icon icon_pay  ${step === 2 ? ' color-brand-2-like' : 'color-ui-3'}`} aria-hidden='true' />
          </div>
        </div>
        <div className='col'>
          <div className='row mx-0 align-items-center h-100'>
            <h1 className={`txt-body txt-uppercase ${step === 2 ? 'color-brand-2-like' : 'color-ui-3'}`}>
              Crédito inicial
            </h1>
          </div>
        </div>
      </div>
    </div>
  )
}

Header.propTypes = {
  step: PropTypes.number.isRequired
}

export default Header



// WEBPACK FOOTER //
// ./src/features/LikePlus/Tabs/RequestCard/Credit/Header.js